import { connect } from 'react-redux'
import compose from 'lib/helpers/compose'
import CheckRow from '../forms/CheckRow'
import TypeIcon from 'components/misc/TypeIcon'
import { toggleFilter } from 'store/report/actions'
import { toggleModal, MODAL_FROM_CONTEXTS } from 'store/ui/actions'
import styles from './styles/Classification.css'

const Row = ({ type, displayText, toggle, count, value }) => (
  <div className={styles.row}>
    <div className={styles.rowLeft}>
      <CheckRow checked={value} toggle={() => toggle(type)}>{displayText || type}</CheckRow>
      <div className={styles.rowType}>
        <TypeIcon type={type} />
      </div>
    </div>
    <div className={styles.rowRight}>
      <span className={styles.count}>{count.toLocaleString()}</span>
    </div>
  </div>
)

export function Classification ({
  toggleFilter,
  toggleModal,
  tally,
  filters: {
    supporting,
    mentioning,
    contradicting,
    unclassified
  },
  fullReport,
  upgradeReport,
  className = ''
}) {
  const handleToggle = (type) => {
    if (!fullReport) {
      toggleFilter('showMobile', false)
      toggleModal(upgradeReport ? 'upgrade' : 'login', true, MODAL_FROM_CONTEXTS.REPORT_FILTER)
      return
    }
    toggleFilter(type)
  }
  return (
    <div className={className}>
      <Row type='supporting' displayText='Supporting' toggle={handleToggle} count={tally?.supporting || 0} value={supporting} />
      <Row type='mentioning' displayText='Mentioning' toggle={handleToggle} count={tally?.mentioning || 0} value={mentioning} />
      <Row type='contradicting' displayText='Contrasting' toggle={handleToggle} count={tally?.contradicting || 0} value={contradicting} />
      {tally?.unclassified !== 0 && <Row type='unclassified' displayText='Unclassified' toggle={handleToggle} count={tally?.unclassified || 0} value={unclassified} />}
    </div>
  )
}

const mapStateToProps = ({ report, ui }) => {
  const referenceTally = report.references.reduce(
    (acc, ref) => {
      const { type } = ref
      if (type === 'supporting') {
        acc.supporting++
      } else if (type === 'mentioning') {
        acc.mentioning++
      } else if (type === 'contradicting') {
        acc.contradicting++
      } else {
        acc.unclassified++
      }
      return acc
    }, {
      supporting: 0,
      mentioning: 0,
      contradicting: 0,
      unclassified: 0
    }
  )
  const tally = report.filters.showReferences ? referenceTally : report.tallies[report.tally]
  return {
    tally,
    filters: report.filters,
    fullReport: !report.metadata?.restrictedCitationCount,
    upgradeReport: !!ui.user
  }
}

export default compose(
  connect(mapStateToProps, { toggleFilter, toggleModal })
)(Classification)
